module.exports = __webpack_public_path__ + "img/Large-Vertical-Rectangular-Attachment-37.9509540a.png";